import { render } from "./quotation.vue?vue&type=template&id=6d7fee4e"
import script from "./quotation.vue?vue&type=script&lang=js"
export * from "./quotation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__